module.exports = __webpack_public_path__ + "img/zhu_yj_zhongshaoliang.8cdf6c25.jpg";